import e from "react";
import { Icon as a } from "../../../general/Icon/Icon.js";
import { cloneAndRender as t } from "../../../../utils/template/index.js";
import l from "../../../../../node_modules/classnames/index.js";
var r = function r(_r) {
  var m = _r.item,
    s = _r.template,
    n = _r.onClick,
    i = _r.templateClasses,
    c = _r.active;
  if (s) return e.createElement(e.Fragment, null, t(s, _r));
  var o = m.title,
    p = m["icon-name"],
    d = m.path,
    f = m.className,
    u = m.iconClassName,
    v = m.external,
    C = m.id;
  return e.createElement("li", {
    id: C,
    className: l("sidebar-item", c && "active", f)
  }, e.createElement("a", {
    target: v ? "_blank" : "_self",
    href: d,
    onClick: n
  }, e.createElement("div", {
    className: i.tooltipTargetClass
  }), e.createElement(a, {
    regular: !0,
    className: u,
    name: p,
    fw: !0
  }), e.createElement("span", {
    className: i.tooltipTextClass
  }, o)));
};
export { r as SidebarItem };